const SESSION_KEY = 'user';
const PERSISTENT_KEY = 'essaar_auth_user';

function readRaw(storage, key) {
  try {
    return storage.getItem(key);
  } catch {
    return null;
  }
}

function writeRaw(storage, key, value) {
  try {
    storage.setItem(key, value);
  } catch {
    /* private mode or quota */
  }
}

function removeRaw(storage, key) {
  try {
    storage.removeItem(key);
  } catch {
    /* ignore */
  }
}

/**
 * Copy a surviving login back into sessionStorage.
 * Mobile Chrome often discards a tab during a phone call and wipes
 * sessionStorage. localStorage survives that, so the same login can resume.
 */
export function restoreAuthSession() {
  const sessionRaw = readRaw(sessionStorage, SESSION_KEY);
  const persistentRaw = readRaw(localStorage, PERSISTENT_KEY);

  if (sessionRaw && !persistentRaw) {
    writeRaw(localStorage, PERSISTENT_KEY, sessionRaw);
    return;
  }

  if (!sessionRaw && persistentRaw) {
    writeRaw(sessionStorage, SESSION_KEY, persistentRaw);
  }
}

export function readAuthUser() {
  restoreAuthSession();
  const raw = readRaw(sessionStorage, SESSION_KEY) || readRaw(localStorage, PERSISTENT_KEY);
  if (!raw) return null;
  try {
    const user = JSON.parse(raw);
    return user && typeof user === 'object' ? user : null;
  } catch {
    clearAuthUser();
    return null;
  }
}

export function writeAuthUser(user) {
  const raw = JSON.stringify(user);
  writeRaw(sessionStorage, SESSION_KEY, raw);
  writeRaw(localStorage, PERSISTENT_KEY, raw);
}

export function clearAuthUser() {
  removeRaw(sessionStorage, SESSION_KEY);
  removeRaw(localStorage, PERSISTENT_KEY);
}

/** Network drops and aborted calls during a phone popup are not a logout. */
export function isTransientAuthError(error) {
  if (!error || !error.response) return true;
  const status = error.response.status;
  if (!status) return true;
  return status === 408 || status === 429 || status >= 500;
}

export function installAuthSessionRestore() {
  restoreAuthSession();
  if (typeof window === 'undefined' || window.__essaarAuthRestoreInstalled) return;
  window.__essaarAuthRestoreInstalled = true;

  const onReturn = () => restoreAuthSession();
  window.addEventListener('pageshow', onReturn);
  window.addEventListener('focus', onReturn);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') onReturn();
  });
}
